<template>
    <paper class="account-manage">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :searchTotalTitle="config.searchTotalTitle"
            :currentPage="currentPage"
            searchId="accountManage"
            pageID="account"
            @edit-btn="editBtn"
            @create-account-btn="handleCreateAccount"
            @reset-password-btn="handleResetPassword"
            @bind-tenant-btn="handleBindTenant"
            @permission-btn="handlePermission"
            @row-db-click="rowDBclick"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange">
            <div slot="table-module-btn" class="btn-box">
                <el-button
                    v-has="'/accountManage-60'"
                    size="mini"
                    :icon="isSensitive ? 'icon-show' : 'icon-hidden'"
                    @click="handleSensitive"
                ></el-button>
            </div>
            <div slot="page-module-btn">
                <span v-has="'04000206'" class="enable-btn">
                    <el-button class="bigData-btn-on" type="primary" @click="handleEnable">启用</el-button>
                </span>
                <span v-has="'04000207'" class="disable-btn">
                    <el-button class="bigData-btn-off" type="primary" @click="handleDisable">停用</el-button>
                </span>
            </div>
        </m-pane>
        <permission-dialog :openPermissionDialog="openPermissionDialog"
                           :row="row"
                           @closeDialog="closePermissionDialog"
                           @confirmDialog="confirmPermissionDialog">
        </permission-dialog>
        <el-dialog
            class="tips-dialog"
            title="提示"
            :visible.sync="openTipsDialog"
            :close-on-click-modal="false"
            top="20%"
            width="350px"
            :before-close="handleTipsDialogClose">
            <span>{{tipsText}}</span>
        </el-dialog>
        <code-verify-dialog
            :visible="codeVisible"
            :userCode="row.userCode"
            :defaultMobile="row.contactsMobile"
            @close="codeVisible = false;"
            @confirm="handleCodeConfirm" />
    </paper>
</template>

<script>
import mPane from '@/components/supplierPanel';
import paper from '@/components/core/paper/Paper';
import config from './config.js';
import { PERSON } from '../../../../constant/constant.js';
import permissionDialog from '../keyData/tabs/person/PermissionDialog.vue';
import { enableToLabel, enableToStatus, accountTypeToLabel, userTypeToLabel, userTypeToStatus } from '../../../../utils/statusOrLabel.js';
import { dictWithUrl } from '@/components/lots/api';
import { getPersons, enablePersons, disablePersons, creatAccount, resetPassword, bindTenant } from '../../../../api/register/person.js';
import CodeVerifyDialog from '../../../../components/CodeVerifyDialog/Index';
import { handleTableDataSensitive } from '../../../../utils/common.js';
const FIVE_HUNDRED = 500;
export default {
    name: 'Index',
    components: { mPane, paper, permissionDialog, CodeVerifyDialog },
    data() {
        return {
            dict: {},
            openAddOrEditDialog: false,
            addOrEdit: false,
            openPermissionDialog: false,
            row: {},
            selected: [],
            searchDataLists: {},
            dataObj: {},
            selectData: [],
            searchObj: {},
            currentPage: 1,
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            totalData: [],
            loading: false,
            config,
            labelPosition: 'right',
            openTipsDialog: false,
            closeOnClickModal: false,
            tipsText: '',
            isSensitive: true, // 列表数据是否脱敏
            codeVisible: false
        };
    },
    methods: {
        handleSensitive() {
            this.onHandleTableDataSensitive(true)
        },
        // 信息脱敏
        onHandleTableDataSensitive(setFlag = false){
            handleTableDataSensitive(this, 'isSensitive', 'totalData', [
                {
                    dataKey: 'idCard',
                    showKey: '_idCard',
                    type: 'idCard'
                },
                {
                    dataKey: 'contactsMobile',
                    showKey: '_contactsMobile',
                    type: 'phone'
                }
            ], setFlag)
        },
        load() {},
        editBtn(data) {},
        pageChange(data) {
            this.isSensitive = true
            this.pageNo = data;
            this.handleGetPerson();
        },
        sizeChange(data) {
            this.isSensitive = true
            this.pageSize = data;
            this.pageNo = 1;
            this.handleGetPerson();
        },
        searchChange(data) {
            this.searchObj = data;
            this.pageNo = 1;
            this.handleGetPerson();
        },
        rowDBclick(row) {},
        selectChange(data) {
            this.selected = [].concat(data);
        },
        handleCreateAccount(row) {
            if (row.userCode) {
                this.$message.warning('已有账号！');
            } else {
                creatAccount(row.id).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('生成成功！');
                        this.handleGetPerson();
                    }
                });
            }
        },
        handleBindTenant(row) {
            const param = { userCode: row.userCode };
            bindTenant(JSON.stringify(param)).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('租户绑定成功！');
                    this.handleGetPerson();
                }
            });
        },
        /** 启用 **/
        handleEnable() {
            if (this.selected.some((e) => enableToStatus(e.contactsStatus) === '0')) {
                this.$message.warning('勾选数据中有已启用数据');
            } else {
                this.handleBatchOperation('enable', '启用');
            }
        },
        /** 停用 **/
        handleDisable() {
            if (this.selected.some((e) => enableToStatus(e.contactsStatus) === '1')) {
                this.$message.warning('勾选数据中有已停用数据');
                return;
            }
            if (this.selected.some((e) => e.userCode === null || e.userCode === '')) {
                this.$message.warning('该联系人目前没有生成账号，不必停用！');
                return;
            }
            this.handleBatchOperation('disable', '停用');
        },
        /** 处理批量操作 **/
        handleBatchOperation(type, text) {
            if (this.selected.length) {
                this.$confirm('是否确定要' + text, text + '确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    const codeArr = [];
                    this.selected.forEach(e => {
                        codeArr.push(String(e.id));
                    });
                    switch (type) {
                    case 'enable':
                        enablePersons(JSON.stringify({ id: codeArr })).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('启用成功!');
                                this.handleGetPerson();
                            }
                        });
                        break;
                    case 'disable':
                        disablePersons(JSON.stringify({ id: codeArr })).then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success('停用成功!');
                                this.handleGetPerson();
                            }
                        });
                        break;
                    }
                });
            } else {
                this.$message.warning('当前没有选中的数据');
            }
        },
        /** 权限分配 **/
        handlePermission(data) {
            if (data.userCode) {
                const row = {
                    sourceUserCode: data.entityCode,
                    userCode: data.userCode,
                    userType: userTypeToStatus(data.userType)
                };
                this.row = row;
                this.openPermissionDialog = true;
            } else {
                this.$message.warning('请生成账号！');
            }
        },
        /** 重置密码 **/
        handleResetPassword(row) {
            this.$confirm('是否确定对账号  ' + row.userCode + '  重置密码', '重置密码', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.row = row;
                this.codeVisible = true;
            });
        },
        handleCodeConfirm(data) {
            const params = {
                userCode: this.row.userCode,
                operator: this.$store.state.user.userCode,
                email: this.row.contactsEmail,
                ...data
            };
            resetPassword(JSON.parse(JSON.stringify(params))).then(res => {
                if (res && res.code === '0') {
                    this.codeVisible = false;
                    setTimeout(() => {
                        const text = res.data.propertyNature === PERSON ? '手机短信' : '邮件验收';
                        this.tipsText = '账号：  ' + this.row.userCode + '  密码已重置，请查看' + text;
                        this.openTipsDialog = true;
                    }, FIVE_HUNDRED);
                }
            });
        },
        handleTipsDialogClose() {
            this.openTipsDialog = false;
        },
        closePermissionDialog(data) {
            this.openPermissionDialog = data;
        },
        confirmPermissionDialog(data) {
            this.openPermissionDialog = data.close;
        },
        formatData(data) {
            return data.map(item => {
                item.supplierStatus = this.dict.SYS_SUPPLIERS_STATUS[item.supplierStatus];
                return item;
            });
        },
        handleHiddenEvent(data) {
            data.forEach(e => {
                e.hiddenEvent = [];
                if (e.userCode) { // 有账号，显示重置密码
                    e.hiddenEvent.push('create-account');
                } else { // 无账号，显示生成账号
                    e.hiddenEvent.push('reset-password');
                }
                if (e.isExistenceTenant) { // 当前账号已绑定当前租户，不需要展示绑定租户按钮
                    e.hiddenEvent.push('bind-tenant');
                }
            });
            return data;
        },
        handleGetPerson(params = { pageNo: this.pageNo, pageSize: this.pageSize, remark: 'accountManagement' }) {
            params = Object.assign(params, this.searchObj);
            getPersons(params).then(res => {
                if (res && +res.code === 0) {
                    this.totalData = res.data.list;
                    this.pageTotal = res.data.totalCount;
                    this.totalData.forEach(e => {
                        e.contactsStatus = enableToLabel(e.contactsStatus);
                        e.accountType = accountTypeToLabel(e.accountType);
                        e.userType = userTypeToLabel(e.userType);
                    });
                    this.totalData = this.formatData(this.totalData);
                    this.totalData = this.handleHiddenEvent(this.totalData);
                    this.onHandleTableDataSensitive()
                }
            }).catch(err => {});
        }
    },
    mounted() {
        dictWithUrl('SYS_SUPPLIERS_STATUS').then(res => {
            this.dict = res.data;
            // this.handleGetPerson();
        });
    }
};
</script>

<style lang="less">
    .account-manage {
        margin: 7px;
        min-width: 1200px;

        .enable-btn,
        .disable-btn {
            margin-left: 8px;
        }

        .tips-dialog {
            .el-dialog__body {
                height: 100px;
                line-height: 80px;
            }
        }
    }
</style>
